<i2a-profile-alert-base-modal
  [manualDescriptionKey]="'applyCorrection.providers.zimbra.mailing.delegate.manual.description'"
  [manualLinkKey]="'applyCorrection.providers.zimbra.mailing.delegate.manual.link'"
  [automaticDescriptionKey]="'applyCorrection.providers.zimbra.mailing.delegate.automatic.description'"
  [ignoreCommentToSend]="session.IgnoreCommentToSend" [displayComment]="session.DisplayComment"
  [validation]="validation" [canSend]="canSend" [modalTitle]="'profile.confirmationOfInformationTitle' | i18next "
  [resourceProfile]="resourceProfile">

  <ng-container header-picto>
    <i2a-resource-photo [providerInstanceResource]="delegate.accesses.providerInstanceResource" [size]="50">
    </i2a-resource-photo>
  </ng-container>

  <ng-container header-title>
    {{delegate.accesses.name}}<br>
    {{delegate.accesses.lastAccess | amDateFormat: 'LLL'}}
  </ng-container>

  <ng-container body>
    <div class="container-fluid">
      <div class="row pt-3" *ngIf="delegate.permissions">

        <div class="form-group col-6 col-sm-4" *ngIf="delegate.permissions.hasSendAsRights">
          <div class="permission">
            <div class="permission-type">
              {{"profile.provider.zimbra.mailing.rights.sendAs" | i18next }}
            </div>
            <div class="permission-checkbox ml-1">
              <i2a-input-checkbox [(model)]="validation.permissions.hasSendAsRightsIsValid"
                [classNameChecked]="'btn-outline-danger'" [className]="'btn-outline-dark'" [valueChecked]="false"
                [valueUnChecked]="true" (modelChange)="setCanSend()"> </i2a-input-checkbox>
            </div>
          </div>
        </div>

        <div class="form-group col-6 col-sm-4" *ngIf="delegate.permissions.hasSendOnBehalfRights">
          <div class="permission">
            <div class="permission-type">
              {{"profile.provider.zimbra.mailing.rights.sendOnBehalf" | i18next }}
            </div>
            <div class="permission-checkbox ml-1">
              <i2a-input-checkbox [(model)]="validation.permissions.hasSendOnBehalfRightsIsValid"
                [classNameChecked]="'btn-outline-danger'" [className]="'btn-outline-dark'" [valueChecked]="false"
                [valueUnChecked]="true" (modelChange)="setCanSend()"> </i2a-input-checkbox>
            </div>
          </div>
        </div>

        <div class="form-group col-6 col-sm-4" *ngIf="delegate.permissions.hasContactsRights">
          <div class="permission">
            <div class="permission-type">
              {{"profile.provider.zimbra.mailing.rights.contacts" | i18next }}
            </div>
            <div class="permission-checkbox ml-1">
              <i2a-input-checkbox [(model)]="validation.permissions.hasContactsRightsIsValid"
                [classNameChecked]="'btn-outline-danger'" [className]="'btn-outline-dark'" [valueChecked]="false"
                [valueUnChecked]="true" (modelChange)="setCanSend()"> </i2a-input-checkbox>
            </div>
          </div>
        </div>


        <div class="form-group col-6 col-sm-4" *ngIf="delegate.permissions.hasCalendarRights">
          <div class="permission">
            <div class="permission-type">
              {{"profile.provider.zimbra.mailing.rights.calendar" | i18next }}
            </div>
            <div class="permission-checkbox ml-1">
              <i2a-input-checkbox [(model)]="validation.permissions.hasCalendarRightsIsValid"
                [classNameChecked]="'btn-outline-danger'" [className]="'btn-outline-dark'" [valueChecked]="false"
                [valueUnChecked]="true" (modelChange)="setCanSend()"> </i2a-input-checkbox>
            </div>
          </div>
        </div>

        <div class="form-group col-6 col-sm-4" *ngIf="delegate.permissions.hasFoldersRights">
          <div class="permission">
            <div class="permission-type">
              {{"profile.provider.zimbra.mailing.rights.folders" | i18next }}
            </div>
            <div class="permission-checkbox ml-1">
              <i2a-input-checkbox [(model)]="validation.permissions.hasFoldersRightsIsValid"
                [classNameChecked]="'btn-outline-danger'" [className]="'btn-outline-dark'" [valueChecked]="false"
                [valueUnChecked]="true" (modelChange)="setCanSend()"> </i2a-input-checkbox>
            </div>
          </div>
        </div>

        <div class="form-group col-6 col-sm-4" *ngIf="delegate.permissions.hasInboxRights">
          <div class="permission">
            <div class="permission-type">
              {{"profile.provider.zimbra.mailing.rights.inbox" | i18next }}
            </div>
            <div class="permission-checkbox ml-1">
              <i2a-input-checkbox [(model)]="validation.permissions.hasInboxRightsIsValid"
                [classNameChecked]="'btn-outline-danger'" [className]="'btn-outline-dark'" [valueChecked]="false"
                [valueUnChecked]="true" (modelChange)="setCanSend()"> </i2a-input-checkbox>
            </div>
          </div>
        </div>


      </div>
    </div>
  </ng-container>

</i2a-profile-alert-base-modal>